/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Option from './Option/index'
import React from 'react'
import TysiaListDialog from 'DesignSystem/TysiaListDialog/index'
import TysiaListDialogItems from 'DesignSystem/TysiaListDialog/TysiaListDialogItems/react'
import TysiaListDialogSearchCapture from 'DesignSystem/TysiaListDialog/TysiaListDialogSearchCapture/index'
import TysiaListDialogTitle from 'DesignSystem/TysiaListDialog/TysiaListDialogTitle/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/New/PatientOptions/Existing/Content/LocationSelect/Content/Content/Content",
  closePopover
  
}) {
let locationsValueData = fromData.useDataValue({ viewPath,
context: 'locations',
})
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<TysiaListDialog
  viewPath={`${viewPath}/TysiaListDialog`}
 data="locations"
 items={locationsValueData}
 width={240}
 height="auto"
 maxHeight={208}
>
{childProps => (
<React.Fragment>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--pl-1-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pr-2-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pt-3-Z1Yf8zk': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--pb-4-Z1Yf8zk': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaListDialogTitle
  viewPath={`${viewPath}/TysiaListDialogTitle`}
 title="Select a location"
/>
</div>
<TysiaListDialogSearchCapture
{...childProps}
  viewPath={`${viewPath}/TysiaListDialogSearchCapture`}
/>
<TysiaListDialogItems
{...childProps}
  viewPath={`${viewPath}/TysiaListDialogItems`}
 itemDataContextName="item"
 paddingLeft={dtSpaceXxs}
 paddingRight={dtSpaceXxs}
 gap={dtSpaceXxs}
>
{childProps => (
<Option
{...childProps}
 closePopover={closePopover}
/>
)}
</TysiaListDialogItems>
</React.Fragment>
)}
</TysiaListDialog>
{children}
</React.Fragment>)
}